import { Provider } from '@angular/core';

import { SVG_SPRITE_URL } from './svg-icon.tokens';

export function provideSvgIcon(config: { spriteUrl?: string }): Provider {
  return { provide: SVG_SPRITE_URL, useValue: config.spriteUrl };
}
